import { Box3, Vector3 } from 'three';

/**
 * Axis Aligned Boudning Box is a oriented bounding is a 3D box. It's width / height / depth don't
 * have to be equal, but the width is always aligned to the X axis, the height to the Y axis and depth to the Z axis.
 * That is to say, this box can't be rotated.
 *
 *```text
 *           +--------------+
 *          /|             /|             Top
 *         / |            / |              *  Back
 *        /  |           /  |              | *
 *       +--------------+   |              |/
 *       |   |          |   |   Left *-----+-----* Right
 *       |   +----------|-- +             /|
 *       |  /           |  /       Front * |
 *       | /            | /                *
 *       |/             |/               Bottom
 *       +--------------+
 * ```
 */
export class AABB3 extends Box3 {
  /**
   * Returns how far the box extends on each side from the center point.
   */
  getExtends(target: Vector3) {
    return this.getSize(target).multiplyScalar(0.5);
  }
}

export default AABB3;
